import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';
import { useTheme } from '@mui/material/styles';
import { Box } from '@mui/material';

Logo.propTypes = {
  disabledLink: PropTypes.bool,
  sx: PropTypes.object,
};

export default function Logo({ disabledLink = false, sx }) {
  const theme = useTheme();
  const PRIMARY_LIGHT = theme.palette.primary.light;
  const PRIMARY_MAIN = theme.palette.primary.main;
  const PRIMARY_DARK = theme.palette.primary.dark;
  const logo = (
    <Box sx={{ width: 40, height: 40, ...sx }}>
      <svg xmlns="http://www.w3.org/2000/svg" width="100%" height="100%" viewBox="0 0 1080.000000 1080.000000" >
        <defs>
          <linearGradient id="BG1" x1="100%" x2="50%" y1="9.946%" y2="50%">
            <stop offset="0%" stopColor={PRIMARY_DARK} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG2" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
          <linearGradient id="BG3" x1="50%" x2="50%" y1="0%" y2="100%">
            <stop offset="0%" stopColor={PRIMARY_LIGHT} />
            <stop offset="100%" stopColor={PRIMARY_MAIN} />
          </linearGradient>
        </defs>
        <g
          fill={PRIMARY_MAIN} stroke="none" strokeWidth="1" fillRule="evenodd"  transform="translate(0.000000,1080.000000) scale(0.100000,-0.100000)">

<path d="M5095 9964 c-22 -2 -103 -11 -180 -20 -883 -97 -1703 -442 -2360
-993 -303 -253 -591 -575 -811 -906 -359 -539 -615 -1206 -703 -1835 -6 -41
-15 -106 -21 -145 -39 -280 -37 -700 4 -1025 144 -1129 669 -2105 1531 -2845
567 -488 1227 -826 1940 -995 161 -38 449 -85 615 -100 183 -17 596 -14 780 4
729 74 1398 313 2017 721 98 65 95 74 -5 16 -309 -179 -811 -373 -1167 -450
-167 -37 -359 -70 -495 -85 -888 -101 -1786 55 -2554 444 -136 69 -393 214
-406 229 -3 3 -39 28 -80 55 -98 64 -260 188 -385 295 -570 489 -1016 1147
-1250 1846 -269 801 -292 1600 -68 2410 97 351 280 775 464 1073 21 35 39 65
39 68 0 3 8 17 19 32 10 15 47 70 81 122 375 566 896 1055 1490 1395 562 323
1162 504 1840 556 461 35 1079 -44 1538 -197 176 -58 141 -35 -68 46 -348 135
-632 207 -1024 261 -117 16 -217 21 -446 24 -162 2 -313 1 -335 -1z"/>
<path d="M5580 9663 c-25 -2 -121 -12 -215 -24 -147 -17 -210 -27 -335 -54
-86 -19 -242 -58 -280 -70 -25 -8 -90 -28 -145 -46 -55 -17 -118 -39 -140 -49
-22 -9 -51 -21 -65 -25 -44 -14 -262 -111 -369 -165 -97 -49 -310 -174 -321
-189 -3 -4 -35 -26 -72 -50 -38 -24 -68 -45 -68 -46 0 -1 67 31 149 71 206
102 416 192 531 228 30 9 78 25 105 35 136 51 449 128 630 156 55 9 128 20
162 25 109 18 413 31 578 24 379 -14 759 -85 1097 -205 79 -28 157 -57 173
-64 17 -7 74 -32 128 -55 102 -44 351 -173 377 -194 8 -7 38 -26 65 -42 28
-15 52 -31 55 -34 3 -3 29 -21 58 -38 30 -18 59 -37 65 -43 7 -5 53 -39 102
-75 316 -233 606 -528 851 -864 109 -149 291 -449 335 -550 5 -13 27 -60 49
-105 97 -203 182 -431 236 -635 80 -299 113 -507 135 -849 21 -328 -24 -773
-111 -1110 -54 -210 -70 -260 -154 -483 -14 -38 -24 -68 -21 -68 6 0 78 153
78 168 0 6 4 12 9 12 4 0 8 8 8 17 0 9 6 24 13 32 8 9 24 41 36 71 13 30 29
69 37 85 20 47 82 225 134 390 31 98 67 258 95 423 8 45 16 86 19 90 2 4 12
95 21 202 40 451 -8 900 -144 1368 -44 151 -100 309 -137 389 -13 28 -24 54
-24 57 0 14 -111 234 -172 341 -62 108 -149 249 -188 306 -46 67 -154 215
-159 219 -4 3 -22 25 -41 50 -19 25 -39 50 -45 56 -5 7 -37 43 -69 80 -86 99
-268 280 -356 354 -41 34 -86 72 -100 83 -49 42 -186 142 -260 190 -41 27 -76
53 -78 58 -2 5 -9 9 -14 9 -6 0 -43 20 -82 44 -102 63 -376 196 -476 231 -22
8 -55 21 -73 28 -93 41 -379 126 -557 165 -262 58 -505 83 -800 80 -118 -1
-235 -3 -260 -5z"/>
<path d="M5263 7808 c-38 -46 -118 -144 -178 -218 -61 -74 -117 -144 -127
-155 -9 -11 -60 -74 -112 -140 -53 -66 -105 -129 -114 -140 -79 -90 -102 -123
-96 -141 5 -16 4 -16 -5 -4 -9 13 -12 12 -25 -5 -8 -11 -24 -31 -36 -45 -12
-14 -34 -41 -49 -60 -14 -19 -29 -37 -32 -40 -12 -10 -99 -120 -99 -125 0 -3
7 -5 15 -5 13 0 14 -2 3 -14 -11 -12 -14 -12 -19 1 -4 12 -14 5 -42 -28 -31
-37 -34 -46 -22 -55 15 -11 21 -73 8 -75 -5 0 -18 -2 -30 -3 -12 -1 -20 1 -17
6 4 5 12 7 19 4 8 -3 13 4 13 19 0 22 -2 23 -16 8 -11 -10 -17 -12 -20 -4 -2
6 -8 9 -13 5 -16 -10 -10 -44 16 -82 27 -39 31 -39 15 3 l-10 25 30 -22 c29
-21 39 -38 21 -38 -14 0 -21 -40 -10 -59 5 -9 14 -29 21 -46 9 -25 12 -27 16
-11 3 15 6 16 14 5 7 -10 8 -8 5 9 -4 18 -1 22 19 22 29 0 30 -3 3 -39 -12
-16 -18 -34 -14 -41 4 -7 3 -15 -2 -19 -6 -3 -8 -20 -6 -37 5 -29 8 -32 35
-27 19 3 34 0 40 -9 7 -10 11 -10 15 0 2 6 16 12 29 12 24 0 31 -10 17 -24 -5
-4 -8 -13 -8 -19 0 -7 -8 -11 -18 -11 -9 1 -15 -2 -12 -6 3 -5 0 -12 -5 -15
-7 -4 -8 -19 -5 -36 4 -16 4 -38 0 -49 -5 -16 -10 -18 -26 -10 -14 8 -19 21
-19 52 0 49 10 44 20 -9 l8 -38 1 36 c1 40 -16 99 -29 99 -13 0 -16 -47 -8
-110 9 -76 8 -235 -1 -292 -4 -27 -4 -48 1 -48 4 0 8 14 8 32 0 17 7 61 16 97
23 98 22 95 39 81 12 -10 15 -9 16 6 0 18 1 18 9 -1 7 -17 9 -17 9 -2 1 9 4
17 9 17 4 0 13 26 21 58 25 111 106 274 144 290 14 7 7 24 -9 18 -9 -3 -12 -2
-9 5 4 6 13 8 21 5 8 -3 24 4 36 16 16 16 17 20 5 15 -9 -3 -17 -2 -17 3 0 6
6 10 14 10 8 0 48 20 89 44 85 50 138 70 229 87 35 6 75 13 91 16 17 3 27 1
27 -7 0 -7 8 -10 20 -7 11 3 41 -2 67 -10 27 -8 75 -15 108 -15 44 -1 52 -3
30 -7 l-30 -7 32 -17 c17 -9 38 -15 45 -14 7 2 9 2 5 -1 -5 -2 9 -16 30 -30
21 -14 60 -48 87 -76 27 -28 56 -50 65 -48 12 2 13 1 3 -6 -12 -8 -7 -42 7
-42 3 0 12 -13 19 -29 9 -21 18 -28 29 -24 11 4 14 2 9 -5 -4 -7 2 -49 14 -95
34 -130 36 -207 10 -307 -26 -95 -67 -181 -106 -222 -14 -15 -22 -32 -19 -38
4 -6 1 -17 -5 -25 -8 -10 -9 -15 -2 -15 6 0 14 5 17 10 13 22 20 8 17 -35 -2
-25 -8 -45 -13 -45 -9 0 -13 14 -10 38 2 16 -17 15 -35 -3 -8 -8 -21 -12 -28
-9 -7 3 -16 -2 -19 -10 -4 -9 -11 -16 -17 -16 -14 0 20 35 43 43 17 6 24 27
10 27 -5 0 -27 -15 -51 -34 -52 -41 -153 -92 -204 -101 -21 -4 -38 -10 -38
-14 0 -4 -54 -8 -120 -9 -66 -1 -120 2 -120 7 0 5 -19 12 -42 16 -24 4 -47 11
-53 15 -18 13 -45 20 -45 11 0 -5 12 -12 27 -16 21 -5 24 -8 12 -16 -18 -11
-42 -12 -35 0 3 4 -7 6 -22 3 -26 -4 -26 -4 -7 12 19 16 19 16 -9 14 -16 -2
-31 2 -33 9 -3 9 5 11 29 7 l33 -5 -30 18 c-40 23 -85 26 -85 4 0 -13 -2 -14
-9 -1 -6 8 -7 18 -5 22 3 4 1 8 -5 8 -16 0 -22 -18 -9 -23 10 -4 10 -6 1 -6
-7 -1 -13 -11 -13 -23 0 -16 -3 -19 -9 -10 -4 7 -12 12 -17 11 -21 -4 -35 2
-29 11 3 6 -1 7 -9 4 -9 -3 -16 -1 -16 5 0 7 -28 11 -80 11 l-80 0 0 -40 0
-40 40 0 40 0 0 -40 c0 -40 0 -40 39 -40 39 0 40 -1 43 -37 l3 -38 58 -3 c31
-2 57 -7 57 -12 0 -6 9 -10 20 -10 11 0 20 5 20 10 0 6 18 10 40 10 l40 0 0
-40 0 -40 -40 0 -40 0 0 -40 c0 -37 2 -40 28 -41 l27 -1 -30 -8 c-16 -4 -24
-8 -16 -9 8 0 12 -3 9 -6 -3 -3 -13 -2 -22 1 -14 5 -15 9 -4 15 10 7 10 9 -2
8 -8 0 -23 -4 -34 -8 -15 -6 -7 -12 39 -29 64 -25 107 -29 60 -7 l-30 15 28
-4 c28 -3 37 8 15 18 -7 3 -3 3 10 0 12 -3 22 -1 22 5 0 17 37 13 55 -5 16
-16 45 -13 45 6 0 5 9 10 20 10 17 0 20 7 20 40 l0 40 40 0 40 0 0 -62 c0 -39
4 -58 9 -49 6 10 10 10 16 1 5 -8 33 -11 84 -9 60 2 79 6 91 21 12 14 23 17
50 12 31 -7 32 -8 11 -16 -12 -4 -20 -12 -17 -17 3 -5 -2 -7 -13 -4 -22 6 -33
-8 -21 -27 7 -11 16 -12 52 -1 62 19 107 40 86 40 -10 1 -18 5 -18 10 0 5 -10
12 -22 14 -17 3 -15 5 9 6 17 0 39 -6 48 -15 14 -14 19 -15 53 0 20 8 30 16
22 16 -8 1 7 8 33 16 l48 15 -22 18 -23 18 35 1 c61 1 67 3 86 24 13 16 14 20
3 16 -8 -2 -23 4 -33 14 -17 18 -17 19 5 28 18 7 19 9 6 9 -14 1 -18 10 -18
41 l0 40 40 0 c38 0 40 1 40 31 0 18 5 50 12 72 9 29 9 42 1 44 -6 2 -9 12 -6
22 3 10 0 22 -7 26 -8 5 -9 -9 -4 -54 l7 -61 -42 0 -41 0 0 40 c0 38 2 40 30
40 28 0 30 2 30 40 0 35 -3 40 -23 40 -31 0 -47 18 -47 52 0 15 -4 28 -10 28
-5 0 -10 -9 -10 -20 0 -11 -5 -20 -10 -20 -6 0 -4 14 5 33 8 17 20 44 26 59
18 45 34 41 30 -8 -2 -32 1 -44 10 -45 8 -1 21 -2 29 -3 8 0 17 -12 21 -26 4
-14 7 -19 8 -12 1 7 5 11 10 8 4 -3 11 15 14 39 4 25 15 62 25 83 26 52 15 91
-17 60 -13 -13 -13 -15 4 68 5 23 9 26 37 20 18 -3 35 -12 40 -19 5 -9 12 -6
24 11 9 13 31 37 49 54 22 19 31 36 28 46 -5 11 -2 14 9 10 15 -6 48 14 90 55
10 9 23 17 28 17 15 0 12 52 -10 159 -16 81 -43 161 -54 161 -1 0 -1 -15 0
-32 l3 -33 -8 35 c-5 19 -7 38 -5 42 6 10 -14 53 -69 146 -36 60 -54 82 -65
77 -20 -7 -52 23 -52 50 0 33 -77 100 -120 104 -33 3 -49 15 -50 35 0 5 9 1
20 -9 11 -10 23 -16 26 -12 9 9 -103 80 -116 72 -6 -3 -9 -1 -8 5 4 15 -151
78 -225 91 -106 18 -164 22 -147 9 12 -9 10 -10 -10 -8 -14 2 -24 9 -23 16 2
8 -15 12 -57 12 -33 0 -60 4 -60 8 0 5 35 50 78 100 42 50 100 119 127 152 56
69 65 80 117 141 21 24 70 84 109 133 39 48 79 98 90 110 10 11 31 37 46 57
15 20 67 85 116 143 48 58 87 108 87 111 0 3 -117 5 -260 5 l-259 0 -68 -82z
m-130 -785 c-6 -15 -33 -18 -33 -3 0 6 7 10 15 10 9 0 12 6 9 18 -5 13 -4 14
4 3 6 -8 8 -20 5 -28z m-503 -37 c0 -3 -4 -8 -10 -11 -5 -3 -10 -1 -10 4 0 6
5 11 10 11 6 0 10 -2 10 -4z m453 -93 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17
0 24 -2 18 -5z m457 -58 c17 -9 30 -17 30 -19 0 -1 -24 -3 -52 -3 -29 0 -41 2
-25 4 28 5 36 18 15 26 -7 3 -9 6 -5 6 4 1 21 -6 37 -14z m-1063 -57 c-3 -8
-6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m1187 -29 c-6 -11 -24 -2 -24
11 0 5 7 7 15 4 8 -4 12 -10 9 -15z m-1211 -3 c4 -10 1 -13 -8 -9 -8 3 -12 9
-9 14 7 12 11 11 17 -5z m-90 -86 c-3 -12 -14 -20 -25 -20 -19 0 -19 1 3 20
13 10 25 19 26 20 0 0 -1 -9 -4 -20z m710 -107 c-7 -2 -21 -2 -30 0 -10 3 -4
5 12 5 17 0 24 -2 18 -5z m337 -11 c3 -3 -12 -2 -33 1 -33 5 -37 4 -27 -8 8
-10 9 -15 2 -15 -6 0 -14 5 -17 10 -3 6 -21 11 -38 11 l-32 2 35 7 c34 7 100
2 110 -8z m-423 2 c-3 -3 -12 -4 -19 -1 -8 3 -5 6 6 6 11 1 17 -2 13 -5z m-47
-8 c0 -11 -19 -15 -25 -6 -3 5 1 10 9 10 9 0 16 -2 16 -4z m1005 -46 c3 -5 1
-10 -4 -10 -6 0 -11 5 -11 10 0 6 2 10 4 10 3 0 8 -4 11 -10z m-1551 -32 c8
-32 7 -48 -3 -48 -5 0 -11 16 -13 35 -4 39 6 48 16 13z m436 18 c0 -2 -7 -7
-16 -10 -8 -3 -12 -2 -9 4 6 10 25 14 25 6z m-470 -27 c0 -11 -4 -17 -10 -14
-5 3 -10 13 -10 21 0 8 5 14 10 14 6 0 10 -9 10 -21z m1155 1 c3 -5 -1 -10
-10 -10 -9 0 -13 5 -10 10 3 6 8 10 10 10 2 0 7 -4 10 -10z m-770 -10 c-3 -5
-11 -10 -16 -10 -6 0 -7 5 -4 10 3 6 11 10 16 10 6 0 7 -4 4 -10z m-30 -50 c8
-13 -5 -13 -25 0 -13 8 -13 10 2 10 9 0 20 -4 23 -10z m-45 -10 c0 -5 -4 -10
-10 -10 -5 0 -10 5 -10 10 0 6 5 10 10 10 6 0 10 -4 10 -10z m1346 -45 c0 -25
-3 -31 -9 -20 -7 13 -2 55 7 55 1 0 2 -16 2 -35z m-1353 -9 c-3 -4 -9 -2 -14
5 -13 22 -11 31 5 17 8 -7 12 -17 9 -22z m-33 -20 c0 -3 -4 -8 -10 -11 -5 -3
-10 -1 -10 4 0 6 5 11 10 11 6 0 10 -2 10 -4z m-30 -66 c-13 -47 -22 -57 -31
-34 -11 27 -10 54 1 29 7 -18 9 -16 15 12 4 18 11 30 15 28 5 -3 5 -19 0 -35z
m1080 0 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1 10 4 10 6 0 11 -4 11
-10z m-1183 -192 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19 0 -25z m1250
10 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4 -12 1 -19z m256 -70 c3 -10 9
-10 26 0 11 6 29 12 38 12 11 0 3 -9 -21 -24 -32 -19 -44 -22 -63 -13 -13 5
-23 14 -23 19 0 5 5 6 10 3 6 -3 10 -1 10 4 0 15 17 14 23 -1z m-228 -68 c8 0
14 -15 17 -40 3 -32 0 -40 -13 -40 -10 0 -19 -6 -22 -12 -2 -7 -4 23 -4 67 0
44 2 68 4 53 2 -16 10 -28 18 -28z m-1328 8 c-3 -7 -5 -2 -5 12 0 14 2 19 5
13 2 -7 2 -19 0 -25z m1300 -240 c-3 -8 -6 -5 -6 6 -1 11 2 17 5 13 3 -3 4
-12 1 -19z m-174 -245 c-7 -2 -21 -2 -30 0 -10 3 -4 5 12 5 17 0 24 -2 18 -5z
m-6 -38 c5 -4 1 -5 -7 -1 -8 4 -5 -1 8 -10 30 -22 28 -34 -7 -34 -31 0 -49 14
-31 25 5 3 10 11 10 16 0 6 -4 7 -10 4 -5 -3 -10 -1 -10 4 0 12 35 9 47 -4z
m-867 -42 c0 -2 -13 -3 -30 -3 -25 0 -30 4 -30 25 l0 26 30 -23 c17 -12 30
-23 30 -25z m716 16 c4 -8 0 -9 -15 -4 -11 3 -21 2 -21 -2 0 -5 -17 -10 -37
-10 l-38 -1 30 13 c38 17 72 18 81 4z m-443 -16 c-7 -2 -19 -2 -25 0 -7 3 -2
5 12 5 14 0 19 -2 13 -5z m661 -235 c-3 -4 0 -8 7 -8 7 0 10 -3 6 -6 -8 -8
-47 5 -47 16 0 5 9 8 19 7 11 0 17 -5 15 -9z"/>
<path d="M8341 7849 c-165 -48 -232 -247 -130 -384 93 -123 289 -128 387 -10
36 44 52 95 52 166 0 155 -157 271 -309 228z m116 -114 c56 -23 78 -59 78
-127 0 -51 -4 -61 -31 -89 -51 -51 -139 -53 -188 -4 -70 70 -47 187 44 224 36
14 54 13 97 -4z"/>
<path d="M2618 7823 c-14 -16 -72 -88 -129 -162 -57 -73 -130 -167 -162 -208
-37 -47 -53 -75 -45 -78 7 -3 291 -6 631 -8 l619 -2 -20 -23 c-11 -13 -34 -40
-50 -60 -187 -232 -258 -320 -421 -522 l-190 -235 272 -6 c150 -3 289 -11 311
-17 84 -23 170 -75 241 -146 118 -119 169 -243 168 -416 -2 -272 -195 -511
-465 -575 -81 -19 -255 -19 -336 0 -170 40 -319 160 -400 320 -38 77 -53 131
-61 225 l-6 75 -214 3 -214 2 6 -107 c13 -252 113 -471 302 -659 145 -144 333
-246 537 -290 168 -36 426 -17 588 43 190 71 374 202 478 342 15 20 29 38 33
41 37 33 132 238 165 360 25 93 26 365 1 468 -68 283 -261 523 -525 656 l-54
27 28 37 c16 20 145 183 289 362 143 178 265 331 272 340 7 8 50 62 96 120 47
58 83 108 80 113 -2 4 -408 7 -902 7 l-897 0 -26 -27z"/>
<path d="M7042 7719 c-155 -17 -353 -77 -482 -147 -282 -153 -519 -419 -635
-710 l-37 -94 59 -61 c79 -84 129 -154 184 -259 l45 -89 13 93 c31 238 129
436 301 609 93 94 161 142 284 200 140 65 229 84 401 84 135 0 159 -3 245 -28
99 -30 222 -87 300 -140 74 -51 214 -197 265 -275 117 -182 165 -341 172 -569
3 -84 7 -153 10 -153 11 0 182 136 257 205 98 89 99 92 71 227 -92 445 -403
831 -810 1006 -201 86 -435 123 -643 101z"/>
<path d="M7380 6345 c0 -562 1 -594 18 -588 43 16 276 124 298 138 l24 15 0
515 0 515 -170 0 -170 0 0 -595z"/>
<path d="M8540 6901 c14 -11 31 -21 38 -21 22 0 104 -84 123 -125 67 -146 -55
-340 -361 -579 -131 -102 -160 -122 -340 -233 -175 -107 -422 -233 -585 -297
-66 -27 -140 -57 -165 -67 -67 -28 -251 -85 -370 -113 -329 -79 -591 -55 -708
65 -74 76 -82 194 -21 318 19 39 33 71 31 71 -8 0 -128 -99 -158 -132 -93 -98
-139 -225 -113 -315 29 -106 163 -189 344 -214 79 -11 95 -16 127 -45 123
-110 364 -229 543 -269 113 -25 330 -30 464 -11 405 60 776 324 981 700 67
122 125 290 150 438 11 64 14 68 68 111 93 72 211 197 263 275 75 115 96 210
62 294 -40 101 -140 154 -308 164 l-90 6 25 -21z m-494 -1128 c-38 -74 -172
-227 -245 -281 -20 -15 -38 -29 -41 -32 -32 -34 -198 -116 -308 -151 -114 -36
-407 -38 -524 -3 -31 9 -20 20 35 33 271 69 699 247 992 414 96 55 111 58 91
20z"/>
<path d="M5875 6590 c10 -11 20 -18 23 -16 5 6 -23 36 -34 36 -4 0 1 -9 11
-20z"/>
<path d="M6940 6090 c0 -433 2 -490 15 -490 9 0 85 23 170 52 l155 51 0 439 0
438 -170 0 -170 0 0 -490z"/>
<path d="M5128 6543 c6 -2 18 -2 25 0 6 3 1 5 -13 5 -14 0 -19 -2 -12 -5z"/>
<path d="M6490 5880 l0 -350 78 0 c74 0 242 23 262 35 6 4 10 132 10 336 l0
329 -175 0 -175 0 0 -350z"/>
<path d="M9807 5990 c6 -157 -12 -481 -38 -666 -74 -533 -276 -1102 -571
-1609 -110 -189 -290 -446 -412 -590 -28 -33 -64 -76 -80 -95 -70 -83 -410
-413 -506 -491 -627 -510 -1367 -830 -2140 -926 -204 -25 -715 -25 -915 0
-251 32 -405 62 -660 130 -71 20 -131 34 -132 33 -5 -5 229 -97 332 -131 208
-68 506 -137 710 -165 294 -40 739 -42 1025 -5 327 43 682 137 990 265 161 66
420 196 515 258 11 7 31 18 45 25 14 7 39 21 55 31 302 195 448 310 670 531
118 117 138 139 255 280 41 50 78 95 83 100 21 25 167 236 167 241 0 3 14 26
31 50 36 53 199 354 221 410 9 21 27 64 42 94 58 125 163 425 201 575 49 192
66 268 88 400 60 348 76 665 52 1025 -19 283 -37 428 -28 230z"/>
<path d="M4490 5865 c-3 -37 -3 -36 5 -57 4 -11 3 -18 -5 -18 -6 0 -8 6 -4 13
5 8 4 9 -4 2 -5 -5 -13 -19 -16 -30 -3 -11 -4 7 -2 40 3 38 1 53 -4 40 -5 -11
-9 -41 -9 -66 -1 -42 -4 -48 -27 -53 -21 -6 -25 -12 -22 -31 3 -13 1 -22 -3
-19 -5 3 -9 -5 -9 -19 0 -21 5 -24 45 -26 l45 -2 0 41 c0 30 4 40 16 40 8 0
12 5 9 10 -8 14 1 13 25 -2 16 -10 22 -10 28 -1 5 8 12 2 21 -18 7 -17 15 -28
18 -26 2 3 -2 18 -10 34 -8 15 -20 58 -27 96 -12 66 -27 85 -37 47 -8 -29 -21
-25 -26 8 l-4 27 -3 -30z"/>
<path d="M5851 5774 c-16 -37 -9 -39 11 -3 9 16 14 29 9 29 -4 0 -13 -12 -20
-26z"/>
<path d="M4560 5660 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4597 5641 c-4 -17 -14 -31 -24 -34 -11 -3 -7 -5 11 -6 20 -1 27 3
23 13 -4 10 0 12 14 9 10 -3 19 -8 19 -12 0 -11 29 -47 30 -36 0 6 -15 29 -34
52 l-34 43 -5 -29z"/>
<path d="M4376 5605 c-9 -26 -7 -32 5 -12 6 10 9 21 6 23 -2 3 -7 -2 -11 -11z"/>
<path d="M4395 5550 c3 -23 2 -30 -4 -21 -14 22 -34 -24 -26 -60 9 -39 20 -37
42 11 14 32 23 40 46 40 20 0 27 5 27 20 0 17 -7 20 -39 20 -22 0 -42 6 -45
13 -4 6 -4 -4 -1 -23z m-8 -72 c-3 -7 -5 -2 -5 12 0 14 2 19 5 13 2 -7 2 -19
0 -25z"/>
<path d="M4346 5530 c-17 -43 -21 -70 -8 -54 12 13 35 85 29 90 -2 3 -12 -13
-21 -36z"/>
<path d="M4644 5547 c1 -15 7 -22 23 -22 11 0 19 3 16 8 -2 4 1 7 7 7 6 0 8 5
4 11 -5 8 -9 8 -14 -1 -5 -8 -11 -7 -22 4 -14 14 -16 13 -14 -7z"/>
<path d="M5570 5535 c-11 -13 -10 -14 4 -9 9 3 16 10 16 15 0 13 -6 11 -20 -6z"/>
<path d="M4727 5493 c-12 -12 -7 -22 8 -17 8 4 15 10 15 15 0 11 -14 12 -23 2z"/>
<path d="M4640 5476 c0 -20 22 -25 37 -10 18 17 17 19 -12 22 -16 1 -25 -3
-25 -12z"/>
<path d="M4780 5460 c0 -5 5 -10 11 -10 5 0 7 5 4 10 -3 6 -8 10 -11 10 -2 0
-4 -4 -4 -10z"/>
<path d="M4335 5450 c-3 -5 1 -10 10 -10 9 0 13 5 10 10 -3 6 -8 10 -10 10 -2
0 -7 -4 -10 -10z"/>
<path d="M5781 5460 c-1 -3 3 -21 9 -40 7 -25 7 -36 -2 -41 -7 -5 -9 -11 -6
-15 4 -3 13 0 21 7 12 12 11 20 -4 54 -10 22 -18 38 -18 35z"/>
<path d="M4306 5435 c-3 -9 -6 -22 -5 -28 0 -7 5 -1 10 12 5 13 8 26 5 28 -2
2 -6 -3 -10 -12z"/>
<path d="M4340 5353 c1 -14 27 -43 39 -43 6 0 11 7 11 15 0 9 -6 12 -15 9 -9
-4 -15 0 -15 10 0 9 -4 16 -10 16 -5 0 -10 -3 -10 -7z"/>
<path d="M5845 5315 c0 -29 29 -53 41 -34 3 6 -4 22 -18 35 l-24 24 1 -25z
m25 -20 c11 -13 10 -14 -4 -9 -9 3 -16 10 -16 15 0 13 6 11 20 -6z"/>
<path d="M4396 5304 c-4 -14 -5 -29 -2 -31 3 -3 8 7 12 21 3 15 4 29 1 32 -2
3 -8 -7 -11 -22z"/>
<path d="M4463 5273 c-15 -5 -17 -23 -4 -23 5 0 11 7 15 15 3 8 4 15 3 14 -1
0 -8 -3 -14 -6z"/>
<path d="M5788 5273 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M4410 5267 c0 -11 71 -87 81 -87 5 0 9 5 9 10 0 6 -7 10 -16 10 -11
0 -15 6 -11 20 3 12 1 17 -5 14 -5 -3 -20 4 -34 17 -13 12 -24 19 -24 16z"/>
<path d="M5763 5255 c4 -9 3 -24 -2 -33 -6 -11 -5 -23 3 -34 11 -15 15 -13 45
13 23 20 29 29 17 29 -9 0 -16 -4 -16 -10 0 -5 -5 -10 -11 -10 -6 0 -9 6 -6
14 3 7 -4 21 -15 31 -19 16 -20 16 -15 0z m22 -63 c-3 -3 -11 0 -18 7 -9 10
-8 11 6 5 10 -3 15 -9 12 -12z"/>
<path d="M4510 5172 c0 -10 22 -32 32 -32 15 0 8 15 -12 28 -11 7 -20 9 -20 4z"/>
<path d="M4675 5172 c-11 -12 -4 -20 23 -24 15 -3 36 -9 47 -13 19 -8 19 -8 2
12 -18 20 -61 35 -72 25z"/>
<path d="M4605 5098 c21 -16 25 -16 54 -2 17 8 31 17 31 20 0 2 -24 3 -54 2
-53 -2 -53 -2 -31 -20z m35 2 c0 -5 -2 -10 -4 -10 -3 0 -8 5 -11 10 -3 6 -1
10 4 10 6 0 11 -4 11 -10z"/>
<path d="M4697 5049 c12 -12 25 -20 28 -17 3 3 -7 13 -22 23 l-28 17 22 -23z"/>
<path d="M5060 5000 c-20 -6 -21 -8 -5 -8 11 0 29 3 40 8 25 11 -1 11 -35 0z"/>
<path d="M4910 4986 c0 -8 5 -18 10 -21 6 -3 10 3 10 14 0 12 -4 21 -10 21 -5
0 -10 -6 -10 -14z"/>
<path d="M5100 4975 c-8 -9 -8 -15 -2 -15 12 0 26 19 19 26 -2 2 -10 -2 -17
-11z"/>
<path d="M5030 4976 c0 -2 11 -6 25 -8 13 -3 22 -1 19 3 -5 9 -44 13 -44 5z"/>
<path d="M5040 4949 c0 -5 19 -9 42 -9 49 0 47 5 -4 13 -21 3 -38 2 -38 -4z"/>
<path d="M5298 4953 c7 -3 16 -2 19 1 4 3 -2 6 -13 5 -11 0 -14 -3 -6 -6z"/>
<path d="M6195 4650 c-58 -12 -145 -53 -179 -85 -92 -89 -87 -277 8 -350 52
-39 112 -61 266 -95 80 -18 161 -40 181 -51 46 -23 64 -67 49 -115 -41 -123
-345 -113 -450 15 l-28 34 -61 -44 c-33 -24 -60 -50 -60 -57 -1 -17 56 -79
105 -112 137 -95 431 -99 565 -8 117 79 151 235 75 346 -46 67 -123 103 -306
142 -80 17 -159 38 -177 46 -109 49 -68 173 63 190 114 14 235 -21 283 -82
l21 -26 60 48 c33 27 60 52 60 57 0 18 -87 91 -133 112 -97 42 -234 56 -342
35z"/>
<path d="M2070 4186 l0 -456 236 0 c271 0 344 11 437 67 79 48 123 96 163 178
65 134 65 298 0 425 -43 85 -57 102 -131 154 -106 76 -124 79 -432 84 l-273 3
0 -455z m537 265 c112 -50 170 -154 160 -286 -9 -127 -72 -214 -182 -252 -38
-14 -83 -18 -190 -18 l-140 0 -3 293 -2 294 152 -4 c134 -3 159 -6 205 -27z"/>
<path d="M3356 4608 c-35 -83 -215 -520 -278 -673 -38 -93 -72 -178 -75 -188
-5 -16 2 -18 92 -15 l97 3 31 80 c17 44 36 83 42 87 5 4 100 8 210 8 110 0
205 -4 211 -8 5 -4 24 -43 40 -87 l30 -80 98 -3 c77 -2 97 0 93 10 -3 7 -30
74 -60 148 -30 74 -85 209 -122 300 -37 91 -93 228 -124 305 l-57 140 -107 3
-108 3 -13 -33z m199 -356 c37 -95 65 -175 62 -178 -2 -2 -70 -3 -149 -2
l-146 3 50 120 c27 66 55 136 63 155 7 19 18 48 24 64 7 16 15 25 20 20 4 -5
38 -87 76 -182z"/>
<path d="M3880 4560 l0 -80 145 0 145 0 0 -375 0 -375 90 0 90 0 0 375 0 375
145 0 145 0 0 80 0 80 -380 0 -380 0 0 -80z"/>
<path d="M4936 4578 c-115 -278 -258 -625 -281 -683 -15 -38 -33 -81 -40 -95
-7 -14 -16 -35 -20 -48 l-7 -23 98 3 98 3 32 85 32 85 218 0 218 0 34 -87 34
-88 94 0 c52 0 94 4 94 9 0 5 -30 80 -66 168 -36 87 -88 212 -114 278 -27 66
-79 191 -115 278 -36 87 -65 163 -65 168 0 5 -49 9 -109 9 l-109 0 -26 -62z
m154 -185 c32 -73 120 -301 120 -313 0 -6 -52 -10 -145 -10 -102 0 -145 3
-145 11 0 7 16 48 34 93 31 71 81 198 99 249 9 25 14 22 37 -30z"/>
<path d="M6840 4356 c0 -156 4 -308 10 -337 25 -137 111 -237 240 -281 117
-40 309 -25 392 30 92 60 148 144 168 252 5 29 10 180 10 336 l0 284 -85 0
-85 0 0 -284 c0 -320 -6 -359 -67 -420 -46 -46 -127 -71 -204 -62 -67 7 -102
22 -142 62 -55 55 -57 70 -57 400 l0 304 -90 0 -90 0 0 -284z"/>
<path d="M7850 4186 l0 -456 234 0 c288 0 365 12 437 66 66 51 92 113 87 205
-4 84 -40 143 -105 174 -23 11 -42 23 -43 27 0 4 12 14 28 23 45 27 80 81 87
136 15 109 -35 201 -134 248 -55 25 -60 26 -323 29 l-268 3 0 -455z m496 289
c74 -31 83 -137 15 -182 -31 -21 -46 -23 -162 -24 -71 -1 -139 -2 -151 -2 -22
-1 -23 1 -26 111 l-3 112 146 0 c105 0 155 -4 181 -15z m6 -358 c70 -18 108
-102 77 -171 -22 -48 -77 -61 -249 -59 l-155 2 -3 107 c-1 59 -1 113 1 118 5
12 285 14 329 3z"/>
<path d="M5319 3472 c-50 -50 -54 -102 -12 -154 15 -18 28 -34 29 -36 1 -1 11
-4 23 -7 11 -2 26 -7 31 -10 18 -11 77 15 106 48 37 41 39 97 5 145 -26 38
-56 52 -107 52 -28 0 -44 -9 -75 -38z"/>
<path d="M4079 3406 c-3 -3 -278 -6 -612 -6 -334 -1 -609 -5 -612 -10 -7 -11
1061 -22 1725 -18 476 3 545 5 545 18 0 13 -66 15 -521 18 -286 1 -523 0 -525
-2z m974 -13 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m-1390
-10 c-13 -2 -33 -2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z m405 0 c-10 -2
-28 -2 -40 0 -13 2 -5 4 17 4 22 1 32 -1 23 -4z"/>
<path d="M5676 3402 c-4 -7 -4 -16 -1 -22 4 -7 244 -10 688 -10 667 0 1481 9
1473 17 -7 8 -219 11 -1177 19 -735 5 -978 4 -983 -4z m1427 -19 c-13 -2 -33
-2 -45 0 -13 2 -3 4 22 4 25 0 35 -2 23 -4z"/>
<path d="M2857 2983 c-4 -3 -7 -51 -7 -105 l0 -98 50 0 c61 0 92 14 113 50 31
52 15 120 -34 146 -29 14 -110 19 -122 7z m103 -38 c70 -36 37 -135 -44 -135
-26 0 -26 1 -26 75 0 69 2 75 20 75 12 0 34 -7 50 -15z"/>
<path d="M3124 2893 c-21 -53 -40 -101 -42 -105 -2 -4 5 -8 16 -8 10 0 24 11
30 26 11 22 17 25 55 22 32 -2 44 -8 52 -25 5 -13 18 -23 27 -23 10 0 18 1 18
3 0 3 -64 164 -77 195 -3 6 -13 12 -23 12 -12 0 -28 -26 -56 -97z m85 -25 c1
-5 -12 -8 -29 -8 -35 0 -34 -3 -14 46 l17 39 13 -35 c7 -19 13 -38 13 -42z"/>
<path d="M3327 2983 c-14 -13 -6 -22 21 -25 27 -3 27 -3 30 -90 2 -69 6 -88
17 -88 12 0 15 18 15 90 0 89 0 90 25 90 16 0 25 6 25 15 0 12 -14 15 -63 15
-35 0 -67 -3 -70 -7z"/>
<path d="M3557 2921 c-15 -38 -34 -85 -42 -105 -14 -34 -14 -36 3 -36 10 0 24
11 30 25 10 21 18 25 55 25 37 0 46 -4 55 -25 6 -14 19 -25 27 -25 19 0 16 14
-25 110 -15 36 -30 73 -33 83 -4 9 -15 17 -25 17 -13 0 -25 -18 -45 -69z m73
-48 c0 -8 -12 -13 -30 -13 -35 0 -34 -3 -14 46 l17 39 13 -30 c7 -16 13 -36
14 -42z"/>
<path d="M4234 2977 c-3 -8 -4 -54 -2 -103 3 -75 6 -89 21 -92 15 -3 17 7 17
102 0 89 -3 106 -15 106 -9 0 -18 -6 -21 -13z"/>
<path d="M4360 2886 c0 -86 3 -106 15 -106 11 0 15 17 17 73 l3 72 50 -72 c29
-42 57 -72 68 -73 15 0 17 12 17 106 0 95 -2 105 -17 102 -15 -3 -18 -15 -20
-66 0 -35 -3 -65 -5 -67 -1 -2 -23 27 -48 63 -25 37 -54 68 -63 70 -15 3 -17
-8 -17 -102z"/>
<path d="M4627 2972 c-35 -38 -16 -75 51 -102 25 -10 32 -18 30 -34 -3 -24
-43 -35 -61 -17 -16 16 -37 14 -37 -4 0 -20 32 -35 74 -35 71 0 89 85 24 110
-45 18 -68 39 -61 56 6 17 37 18 63 2 27 -17 37 -2 15 22 -23 25 -76 26 -98 2z"/>
<path d="M4830 2885 c0 -87 3 -105 15 -105 12 0 15 18 15 105 0 87 -3 105 -15
105 -12 0 -15 -18 -15 -105z"/>
<path d="M4987 2979 c-25 -15 -47 -63 -47 -104 0 -84 113 -129 173 -70 24 24
40 69 29 80 -3 3 -27 5 -54 5 -36 0 -48 -4 -48 -15 0 -10 10 -15 29 -15 38 0
46 -13 22 -34 -28 -25 -79 -17 -104 16 -26 35 -14 86 25 108 23 12 32 12 63 1
50 -18 70 1 27 23 -35 18 -88 20 -115 5z"/>
<path d="M5220 2885 c0 -87 3 -105 15 -105 11 0 15 12 15 45 l0 45 50 0 50 0
0 -45 c0 -33 4 -45 15 -45 12 0 15 18 15 105 0 85 -3 105 -14 105 -10 0 -16
-14 -18 -42 l-3 -43 -45 0 -45 0 -3 43 c-2 28 -8 42 -18 42 -11 0 -14 -20 -14
-105z"/>
<path d="M5450 2975 c0 -9 9 -15 25 -15 25 0 25 -1 25 -90 0 -83 1 -90 20 -90
19 0 20 7 20 90 0 89 0 90 25 90 16 0 25 6 25 15 0 12 -14 15 -70 15 -56 0
-70 -3 -70 -15z"/>
<path d="M6144 2982 c-6 -4 -16 -17 -23 -30 -16 -30 6 -67 46 -77 56 -14 72
-50 28 -61 -17 -4 -32 -1 -43 9 -12 11 -22 13 -32 7 -25 -16 16 -50 61 -50 47
0 71 22 67 64 -3 26 -11 35 -50 54 -48 22 -62 47 -32 59 8 3 27 0 40 -6 34
-15 50 -4 28 20 -17 19 -69 26 -90 11z"/>
<path d="M6368 2973 c-68 -42 -63 -145 9 -182 72 -37 153 12 153 91 -1 87 -88
136 -162 91z m107 -38 c67 -66 -23 -166 -96 -106 -17 13 -23 29 -23 56 0 69
71 99 119 50z"/>
<path d="M6609 2986 c-2 -2 -3 -50 -1 -105 l3 -101 55 0 c41 0 54 4 54 15 0
11 -11 15 -40 15 l-40 0 0 90 c0 68 -3 90 -13 90 -8 0 -16 -2 -18 -4z"/>
<path d="M6790 2907 c0 -101 14 -127 66 -127 48 0 70 14 83 52 15 42 4 158
-15 158 -11 0 -14 -19 -14 -78 0 -83 -9 -102 -47 -102 -32 0 -43 28 -43 109 0
56 -3 71 -15 71 -12 0 -15 -16 -15 -83z"/>
<path d="M7010 2975 c0 -9 9 -15 25 -15 24 0 25 -2 25 -74 0 -83 6 -106 26
-106 10 0 14 22 16 88 l3 87 28 3 c16 2 27 8 24 15 -2 7 -32 13 -75 15 -60 2
-72 0 -72 -13z"/>
<path d="M7220 2885 c0 -98 1 -105 20 -105 19 0 20 7 20 105 0 98 -1 105 -20
105 -19 0 -20 -7 -20 -105z"/>
<path d="M7372 2965 c-78 -65 -34 -185 68 -185 74 0 122 62 101 130 -15 49
-41 71 -94 77 -36 4 -48 1 -75 -22z m113 -30 c31 -30 32 -71 3 -102 -44 -47
-118 -16 -118 49 0 38 34 78 67 78 13 0 35 -11 48 -25z"/>
<path d="M7620 2885 c0 -87 3 -105 15 -105 12 0 15 14 15 65 0 36 4 65 8 65 5
0 30 -29 56 -65 68 -92 76 -88 76 40 0 85 -3 105 -15 105 -11 0 -15 -17 -17
-72 l-3 -71 -54 71 c-30 40 -61 72 -68 72 -10 0 -13 -25 -13 -105z"/>
<path d="M7887 2972 c-34 -38 -11 -85 49 -101 38 -10 42 -54 5 -59 -13 -2 -28
1 -34 7 -16 16 -37 14 -37 -4 0 -20 32 -35 74 -35 27 0 40 6 52 25 25 38 12
67 -41 93 -46 22 -58 48 -29 59 9 3 25 1 35 -5 24 -15 39 -15 39 -1 0 37 -85
52 -113 21z"/>
<path d="M3938 2916 c-24 -18 -23 -48 3 -64 30 -19 56 -7 57 26 0 48 -26 64
-60 38z"/>
<path d="M5828 2919 c-44 -25 -3 -93 42 -69 26 14 26 56 1 70 -23 12 -22 12
-43 -1z"/>
</g>
</svg>







    </Box>
  );
  if (disabledLink) {
    return <>{logo}</>;
  }

  return <RouterLink to="">{logo}</RouterLink>
}
